import React from 'react';

// Small pieces shared by the Competitors page and the sub finder.

export function Chip({ children, color = '#aaa', title }) {
  return <span title={title} style={{ fontSize: '10px', padding: '1px 7px', borderRadius: '8px', border: `1px solid ${color}55`, color, marginLeft: '6px' }}>{children}</span>;
}

// What the finder's check read in a sub's rules: a hint, rules can be vague
// and AutoModerator's own limits are never visible.
export function RuleHints({ check }) {
  if (!check || !['checked', 'added', 'too_small'].includes(check.status) || check.mentions_verification == null) return <span style={{ color: '#555' }}>—</span>;
  const hints = [
    check.mentions_verification && 'verification',
    check.mentions_karma && 'karma',
    check.mentions_account_age && 'account age'
  ].filter(Boolean);
  return hints.length
    ? <span style={{ color: '#f59e0b' }} title="The sub's rules mention these">{hints.join(' · ')}</span>
    : <span style={{ color: '#22c55e' }} title="The rules mention no verification, karma or account-age requirement (AutoModerator limits can't be seen)">none found</span>;
}
